import script from "./ModalRenameGroup.vue?vue&type=script&setup=true&lang=js"
export * from "./ModalRenameGroup.vue?vue&type=script&setup=true&lang=js"

import "./ModalRenameGroup.vue?vue&type=style&index=0&id=69c20930&lang=css&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-69c20930"]])

export default __exports__